import { Iata } from '@reward-platform/platform-config'

/** Household redemption is available for BA and IB. */
export const isHouseholdRedemptionEnabledForOpCo = (opCo: Iata): boolean =>
  opCo === 'BA' || opCo === 'IB'
